import contentWizardController from "./controllers/contentWizardController";

(function (angular) {
	'use strict';

	var contentWizardApp = angular.module('AopaContentWizard', ['ngMaterial']);

	contentWizardApp.controller('contentWizardController', ['$scope', '$http', '$window', contentWizardController]);
})(window.angular);
